export const MODIFY_IMPORT_SHEETS_UPLOAD_PK = 'MODIFY_IMPORT_SHEETS_UPLOAD_PK';

export function modifyImportSheetsUploadPK(importSheetsUploadPK){
    return{
        type: MODIFY_IMPORT_SHEETS_UPLOAD_PK,
        mainState: {
            importSheetsUploadPK: importSheetsUploadPK
        }
    }
}